import React, { useState, useEffect, useRef, useCallback } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import Select from "react-select";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PromptGeneric from "../Modal/PromptGeneric";
import { DeleteWorkCard } from "../../actions/teacherMutations";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

const CreateAPLPeriodWorkCard = ({
  setWorkcard,
  aplValidationErrors,
  setAplValidationErrors,
  existingWorkCards,
  intl,
  setPage,
  defaultSelectedWorkCard,
  aplWorkcard,
}) => {
  const [selectedWorkCard, setSelectedWorkCard] = useState(
    defaultSelectedWorkCard !== null
      ? {
          value: defaultSelectedWorkCard,
          label: defaultSelectedWorkCard.name,
        }
      : aplWorkcard !== null
      ? { value: aplWorkcard, label: aplWorkcard.name }
      : null
  );
  const [selectableWorkCards, setSelectableWorkCards] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const workCardSelectRef = useRef(null);
  const [workCardMenuIsOpen, setworkCardMenuIsOpen] = useState(false);
  const [workCardForPromptDelete, setWorkCardForPromptDelete] = useState(null);

  const queryClient = useQueryClient();
  const mutateDeleteWorkCard = useMutation(DeleteWorkCard);

  const handleChange = useCallback(
    (value) => {
      setAplValidationErrors(
        aplValidationErrors.filter((item) => item !== "aplWorkcard")
      );
      setSelectedWorkCard(value);
      setWorkcard(value.value);
      workCardSelectRef.current.blur();
      setworkCardMenuIsOpen(false);
    },
    [aplValidationErrors, setAplValidationErrors, setWorkcard]
  );

  useEffect(() => {
    let tempSelectableWorkCards = [];
    existingWorkCards.forEach((wc) => {
      let workcard = {
        value: wc,
        label: (
          <Row
            style={{ margin: "-8px", height: "3em", alignContent: "center" }}
          >
            <Col
              className="delete-wc-col"
              onClick={() => {
                setWorkCardForPromptDelete(wc);
              }}
            >
              <Button color="danger" outline size="sm">
                <FontAwesomeIcon icon="trash" />
              </Button>
            </Col>
            <Col
              style={{ alignContent: "center" }}
              lg="10"
              onClick={() => handleChange({ value: wc, label: wc.name })}
            >
              {wc.name}
            </Col>
          </Row>
        ),
      };
      tempSelectableWorkCards.push(workcard);
    });
    setSelectableWorkCards(tempSelectableWorkCards);
  }, [existingWorkCards, handleChange]);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const openInfoModal = () => {
    setIsOpen(true);
  };

  const handleOpenCreateWorkcardPage = () => {
    setPage(0);
  };

  const handleDeleteWorkCard = () => {
    mutateDeleteWorkCard.mutate(workCardForPromptDelete.id, {
      onSuccess: () => {
        queryClient.invalidateQueries(["FetchWorkCards"]);
        setWorkCardForPromptDelete(null);
      },
      throwOnError: true,
      onError: (data) => {
        setWorkCardForPromptDelete(null);
        toast.warn(data.response.data);
      },
    });
  };

  return (
    <>
      <p
        className="lead"
        style={{ fontSize: 14, marginTop: 15, whiteSpace: "pre-wrap" }}
      >
        <FormattedMessage id="HowToStepOne_2" />
      </p>
      <Button
        style={{ marginTop: 0, marginBottom: 15 }}
        outline
        color="primary"
        onClick={() => handleOpenCreateWorkcardPage()}
      >
        <FormattedMessage id="CreateNewWorkCard" />
      </Button>
      <Button
        size="xs"
        style={{
          marginTop: 0,
          marginBottom: 15,
          marginLeft: 15,
          borderRadius: "50%",
        }}
        onClick={openInfoModal}
        color="primary"
        outline
      >
        <FontAwesomeIcon icon="info" />
      </Button>
      {selectableWorkCards.length > 0 && (
        <>
          <p
            className="lead"
            style={{ fontSize: 14, marginTop: 15, whiteSpace: "pre-wrap" }}
          >
            <FormattedMessage id="HowToStepOne" />
          </p>

          <Select
            ref={workCardSelectRef}
            menuIsOpen={workCardMenuIsOpen}
            onFocus={() => setworkCardMenuIsOpen(true)}
            onBlur={() => setworkCardMenuIsOpen(false)}
            value={selectedWorkCard}
            placeholder={intl.formatMessage({ id: "ChooseWorkCard" })}
            options={selectableWorkCards}
          />
        </>
      )}
      {aplValidationErrors.some((item) => item === "aplWorkcard") ? (
        <p className="text-danger">
          <FormattedMessage id="ThePeriodMustInculedWorkCard" />
        </p>
      ) : (
        ""
      )}
      <PromptGeneric
        onProceed={handleDeleteWorkCard}
        toggle={() => {
          setWorkCardForPromptDelete(null);
        }}
        isOpen={workCardForPromptDelete !== null}
        title={<FormattedMessage id="AreYouSure" />}
        text={intl.formatMessage(
          { id: "AreYouSureYouWantToDeleteWorkCardName" },
          {
            name: workCardForPromptDelete?.name,
          }
        )}
        danger={true}
      />

      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader>
          <FormattedMessage id="HowToStepOne_3" />
        </ModalHeader>
        <ModalBody>
          <p>
            <FormattedMessage id="HowToStepOne_Line1" />
          </p>
          <p>
            <FormattedMessage id="HowToStepOne_Line2" />
          </p>
          <p>
            <FormattedMessage id="HowToStepOne_Line3" />
          </p>
          <p>
            <FormattedMessage id="HowToStepOne_Line4" />
          </p>
          <p>
            <FormattedMessage id="HowToStepOne_Line5" />
          </p>
          <p>
            <FormattedMessage id="HowToStepOne_Line6" />
          </p>
          <p>
            <FormattedMessage id="HowToStepOne_Line7" />
          </p>
        </ModalBody>
        <ModalFooter>
          <Button onClick={toggle} outline color="primary">
            <FormattedMessage id="Close" />
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default injectIntl(CreateAPLPeriodWorkCard);
